"use client";

import { usePathname } from "next/navigation";
import { CartProvider } from "./[businessSlug]/CartContext";

/**
 * Wraps book layout children with CartProvider. Slug comes from pathname so nav and page share cart state.
 * Always renders the same wrapper to avoid hydration mismatch; CartProvider accepts null slug (empty cart).
 */
function getBusinessSlugFromPathname(pathname: string): string | null {
  const segments = pathname.split("/").filter(Boolean);
  if (segments[0] !== "book" || !segments[1]) return null;
  if (segments[1] === "demo") return null;
  return segments[1];
}

export function BookLayoutWithCart({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const businessSlug = pathname ? getBusinessSlugFromPathname(pathname) : null;

  return (
    <CartProvider businessSlug={businessSlug}>
      {children}
    </CartProvider>
  );
}
